
import React, { useEffect, useRef, useState } from "react";
import sideImage from "./Cloudimages/restur.jpg";
const Landingfoodpage = () => {
    const textRef = useRef(null);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setAnimate(true);
            },
            { threshold: 0.3 }
        );
        if (textRef.current) observer.observe(textRef.current);
        return () => {
            if (textRef.current) observer.unobserve(textRef.current);
        };
    }, []);

    return (
        <div style={styles.container}>
            {/* Top Center About Heading */}
            <h2 style={styles.sectionHeading}>Food And Beverages</h2>

            <div style={styles.wrapper} className="main-home-about">
                {/* Left Animated Text */}
                <div
                    ref={textRef}
                    style={{
                        ...styles.left,
                        transform: animate ? "translateY(0px)" : "translateY(50px)",
                        opacity: animate ? 1 : 0,
                        transition: "all 0.8s ease",
                    }}
                    className="lading-abouts"
                >
                    <h1 style={styles.heading}>Food and Beverages</h1>
                    <p style={styles.description}>
                        At <strong>Maamaas</strong>, we’re redefining the way food and beverage
                        businesses connect with customers. Whether you run a restaurant, café,
                        bakery, catering service, or cloud kitchen — we provide the tools you
                        need to grow your brand digitally.
                        <br /><br />
                        Our platform eliminates heavy commissions and unnecessary middlemen,
                        allowing you to manage your menus, orders, and payments seamlessly — all
                        under one dashboard. Build your online presence, attract new customers,
                        and take complete control of your business with zero hassle.

                    </p>
                </div>

                {/* Right Image */}
                <div style={styles.right} className="lading-about">
                    <img src={sideImage} alt="Food and Beverages" style={styles.image} />
                </div>
            </div>

        </div>
    );
};

// ✅ Inline Styles
const styles = {
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 10px",
    },
    sectionHeading: {
        textAlign: "center",
        fontSize: "28px",
        fontWeight: "bold",
        fontFamily: "'SF Pro', sans-serif",
        color: "#b15cd6",
        marginBottom: "10px",
        marginTop: "0px",
    },
    wrapper: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center", // ✅ Align items vertically
        justifyContent: "space-between",
        gap: "30px", // ✅ Gap between text and image
        width: "100%",
        maxWidth: "64vw",
        backgroundColor: "#f9f9f9",
        padding: "30px 20px",
        borderRadius: "12px",
    },
    left: {
        flex: "1 1 50%",
        // minWidth: "280px",
        marginTop: "10px",
    },
    right: {
        flex: "1 1 45%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // minWidth: "260px",
        marginTop: "10px",
    },
    heading: {
        fontSize: "2rem",
        fontWeight: "bold",
        marginBottom: "15px",
        color: "#222",
    },
    description: {
        fontSize: "1rem",
        lineHeight: "1.6",
        color: "#555",
    },
    image: {
        width: "100%",
        maxWidth: "350px",
        height: "250px",
        borderRadius: "10px",
        objectFit: "cover",
    },
};

export default Landingfoodpage;
